<agr-wrapper-site-sidenav [navigationItems]="navigationItems" data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
<app-field-advice-customer-selection-custom-config></app-field-advice-customer-selection-custom-config>
